import React from 'react';
import Info from '../../foundations/pictograms/info_outline_grey.svg';
import { textBodySmall } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { Picto } from '../Picto';
import { Popover } from '../Popover';
import { PictoName } from '../Picto/pictosLibrary';
import { IllustrationName } from '../Picto/illustrationLibrary';
export interface PricingBannerProps {
  title: string;
  subtitle?: string;
  subtitleMobile?: string;
  icon?: IllustrationName | PictoName;
  popupTitle?: string;
  popupSubtitle: string;
  screenSize?: string;
  className?: string;
}

export const Banner = ({
  title,
  subtitle,
  subtitleMobile,
  icon,
  popupTitle,
  popupSubtitle,
  screenSize,
  className,
}: PricingBannerProps) => {
  let subtitleToDisplay;

  if (screenSize && screenSize === 'xs') {
    subtitleToDisplay = null;
  } else if (screenSize && screenSize === 'sm') {
    subtitleToDisplay = subtitleMobile;
  } else {
    subtitleToDisplay = subtitle;
  }

  return (
    <div
      className={classNames(
        'PricingBanner flex w-full flex-row gap-[10px] rounded-6 border border-solid border-neutral-21 bg-lang-31 p-16 md:gap-[16px]',
        className,
      )}
    >
      {icon && (
        <Picto
          className="shrink-0 !p-0"
          name={icon}
          width={46}
          height={46}
        ></Picto>
      )}
      <div className="flex flex-col justify-center gap-[2px]">
        <div className={classNames('text-14')}>
          <div className="font-medium">
            {title}
            <div className="inline-block font-normal">
              {popupTitle && (
                <Popover
                  label={
                    <Info
                      className={classNames(
                        'inline-block',
                        'mb-[3px] ml-8 h-[15px] w-[15px]',
                      )}
                    />
                  }
                  className="text-navy-80"
                >
                  <div className="md:w-[280px]">
                    <div className="pb-8 font-sans text-16 leading-22">
                      {popupTitle}
                    </div>
                    <div className="pb-8 font-sans text-12 leading-16">
                      {popupSubtitle}
                    </div>
                  </div>
                </Popover>
              )}
            </div>
          </div>
        </div>
        <div className={classNames(textBodySmall, 'text-navy-80')}>
          {subtitleToDisplay}
        </div>
      </div>
    </div>
  );
};
